import React from 'react'
import { IProps as ISubNav, SubNav } from 'marketing-site/src/mvp/library/components/SubNav'
import { IProps as ISubNavItem } from 'marketing-site/src/mvp/library/components/SubNavItem'
import {
  ISubNavItem as IContentfulSubNavItem,
  IHeaderNavigationGridLinkBadge as IContentfulIHeaderNavigationGridLinkBadge,
} from 'marketing-site/@types/generated/contentful'
import { ISubNav as IContentfulSubNav } from 'marketing-site/@types/generated/contentful'

import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { IHeaderNavigationLinkBadge } from 'marketing-site/src/library/components/HeaderNavigationGrid'
import { camelCase } from 'lodash'

export const ContentfulSubNav = (secondaryNav: IContentfulSubNav): React.ReactElement => {
  return (
    <EntryMarker entry={secondaryNav}>
      {() => <SubNav {...transformSubNav(secondaryNav)} />}
    </EntryMarker>
  )
}

export function transformSubNav({ fields }: IContentfulSubNav): ISubNav {
  const transformedData: ISubNav = {
    ...fields,
    navTitle: fields.title,
    navItems: fields.items.map((item: IContentfulSubNavItem) => transformSubNavItem(item)),
  }
  return transformedData
}

function transformSubNavItem({ fields }: IContentfulSubNavItem): ISubNavItem {
  return {
    ...fields,
    badge: fields.badge ? transformHeaderNavigationLinkBadge(fields.badge) : undefined,
  }
}

export const transformHeaderNavigationLinkBadge = ({
  fields,
}: IContentfulIHeaderNavigationGridLinkBadge): IHeaderNavigationLinkBadge => {
  return {
    ...fields,
    textColor:
      fields.textColor && (camelCase(fields.textColor) as IHeaderNavigationLinkBadge['textColor']),
    color: fields.color && (camelCase(fields.color) as IHeaderNavigationLinkBadge['color']),
  }
}
